document.addEventListener('DOMContentLoaded', function () {

  const openBtn = document.querySelector('[data-compliance-open]');
  const modal = document.querySelector('[data-compliance-modal]');
  const closeBtns = document.querySelectorAll('[data-compliance-close]');

  if (!openBtn || !modal) return;

  let lastFocusedElement = null;

  function openModal() {
    lastFocusedElement = document.activeElement;
    modal.classList.add('is-active');
    document.body.classList.add('compliance-modal-open');
    const closeButton = modal.querySelector('.compliance-modal-close');
    if (closeButton) {
      closeButton.focus();
    }
  }

  function closeModal() {
    modal.classList.remove('is-active');
    document.body.classList.remove('compliance-modal-open');
    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  function getFocusableElements() {
    return modal.querySelectorAll(
      'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
  }

  openBtn.addEventListener('click', function (e) {
    e.preventDefault();
    openModal();
  });

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      closeModal();
    });
  });

  modal.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    const focusableElements = getFocusableElements();
    if (focusableElements.length === 0) return;
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    // Shift + Tab
    if (e.shiftKey) {
      if (document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      }
    }
    // Tab
    else {
      if (document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  });
  /* ===========================
     Image Viewer
  =========================== */

  const viewer = document.querySelector('[data-image-viewer]');
  const preview = document.querySelector('[data-image-preview]');
  let panzoomInstance = null;

  document.querySelectorAll('.compliance-safety-image').forEach(function (image) {

    image.addEventListener('click', function () {

      const gallery = document.querySelector('product-gallery');
      console.log(gallery);

      if (!gallery) return;

      const dataSource = [{
        thumbnailElement: image,
        src: image.dataset.fullImage,
        srcset: image.srcset,
        msrc: image.currentSrc || image.dataset.fullImage,
        width: parseInt(image.getAttribute('width')),
        height: parseInt(image.getAttribute('height')),
        alt: image.alt,
        thumbCropped: true
      }];

      gallery.photoswipe.loadAndOpen(0, dataSource);

    });

  });
  document.querySelectorAll('[data-image-close]').forEach(function (button) {

    button.addEventListener('click', function () {

      viewer.classList.remove('is-active');

      preview.removeAttribute('src');

      if (panzoomInstance) {
        panzoomInstance.destroy();
        panzoomInstance = null;
      }

    });

  });

});